import React from 'react';
import { Router } from "react-router-dom";
import { Notifyer } from "@myplay/ui";

import './App.scss';
import { Routes, AppLayout } from '../../components';
import history from '../../utils/history';

const App = () => {
  return (
    <div className="App">
      <Router history={history}>
        <Notifyer>
          <AppLayout>
            <Routes/>      
          </AppLayout>
        </Notifyer>
      </Router> 
    </div>
  );
}

export default App;